import { errorActions } from '@content-platform/web-angular-shared-util-error-handling';
export const LOAD_BY_ID = '[UserPermissionList] LOAD BY ID';
export const LOAD_BY_ID_SUCCESS = '[UserPermissionList] LOAD BY ID SUCCESS';
export const USER_ROLE_UPDATE_LOAD_BY_ID_SUCCESS = '[UserPermissionList] USER ROLE UPDATE LOAD BY ID SUCCESS';
export const LOAD_BY_ID_FAILED = '[UserPermissionList] LOAD BY ID FAILED';
export const LOAD_DEFAULT_PERMISSIONS_FOR_DIRECT_ACCESS = '[UserPermissionList] LOAD DEFAULT PERMISSIONS FOR DIRECT ACCESS';
export const UPDATE_FAILED = '[UserPermissionList] UPDATE FAILED';
export const DELETE_FAILED = '[UserPermissionList] DELETE FAILED';
export const CREATE_FAILED = '[UserPermissionList] CREATE FAILED';
export class LoadById {
    constructor(payload) {
        this.payload = payload;
        this.type = LOAD_BY_ID;
    }
}
export class LoadByIdSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = LOAD_BY_ID_SUCCESS;
    }
}
export class UserRoleUpdateLoadByIdSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = USER_ROLE_UPDATE_LOAD_BY_ID_SUCCESS;
    }
}
export class LoadFailed extends errorActions.Fail {
    constructor() {
        super(...arguments);
        this.type = LOAD_BY_ID_FAILED;
    }
}
export class LoadDefaultPermissionsForDirectAccess {
    constructor() {
        this.type = LOAD_DEFAULT_PERMISSIONS_FOR_DIRECT_ACCESS;
    }
}
//# sourceMappingURL=user-permission-list.actions.js.map